// src/routes/UserRoutes.jsx
const UserRoutes = {
  children: []
};

export default UserRoutes;